<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->

          <!-- Search -->
          <b-col cols="12" lg="8">
            <b-row class="align-items-center">
              <b-col lg="6" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model.trim="searchQuery"
                    @keyup.enter="onSearch()"
                    class="d-inline-block round"
                    :placeholder="$t('textPlaceholderSearchUser')"
                  />
                </div>
              </b-col>
              <b-col
                cols="12"
                md="4"
                lg="4"
                class="d-flex align-items-center justify-content-center justify-content-lg-start p-0 my-1 m-lg-0"
              >
                <b-button
                  class="round px-5"
                  variant="primary"
                  :disabled="searchQuery ? false : true"
                  @click="onSearch"
                >
                  {{ $t("search") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" class="round" @click="New()">
              {{ $t("addUser") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-table responsive hover :items="items" :fields="fields">
        <template #cell(actions)="row">
          <div class="d-flex gap-10">
            <!-- <b-button
              v-b-tooltip.hover.top="$t('updateRole')"
              variant="primary"
              size="sm"
              @click="Permission(row.item, row.index, $event.target)"
            >
              <feather-icon icon="UserCheckIcon" />
            </b-button> -->
            <b-button
              v-b-tooltip.hover.top="$t('changePassword')"
              variant="primary"
              size="sm"
              @click="ChangePas(row.item, row.index, $event.target)"
            >
              <feather-icon icon="KeyIcon" />
            </b-button>
            <b-button
              v-b-tooltip.hover.top="$t('updateInfo')"
              variant="primary"
              size="sm"
              @click="Edit(row.item, row.index, $event.target)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button
              v-b-tooltip.hover.top="$t('Task')"
              variant="primary"
              size="sm"
              @click="taskInfoBooking(row.item)"
            >
              <feather-icon icon="InfoIcon" />
            </b-button>
            <b-button
              v-b-tooltip.hover.top="$t('deleteUser')"
              v-if="
                row.item.USER_TYPE != $Utils.CONSTANTS.USER_TYPE_O.Admin
                  ? true
                  : false
              "
              variant="danger"
              size="sm"
              @click="Delete(row.item, row.index, $event.target)"
            >
              <feather-icon icon="DeleteIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t("showing") }} </label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            style="min-width: 60px"
            class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
          />
          <label>{{ $t("entries") }}</label>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      id="modal-edit"
      no-close-on-backdrop
      size="lg"
      :title="modal_title"
      @ok="handleOk"
    >
      <validation-observer ref="simpleRules">
        <b-row>
          <b-col cols="3">
            <validation-provider
              :name="$t('userName')"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label
                  >{{ $t("userName") }}<span class="required">*</span>
                </label>

                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.ID"
                  :readonly="readonly()"
                  :placeholder="$t('userName')"
                />
                <small v-show="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="3">
            <b-form-group :label="$t('staffCode')">
              <b-form-input
                v-model="currentItem.MA_NV"
                :placeholder="$t('staffCode')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <validation-provider
              :name="$t('fullName')"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label
                  >{{ $t("fullName") }}<span class="required">*</span>
                </label>

                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.FULL_NAME"
                  :placeholder="$t('fullName')"
                />
                <small v-show="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <validation-provider name="FAST ID" #default="{ errors }" rules="">
              <b-form-group label="FAST ID">
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.FAST_ID"
                  placeholder="FAST ID"
                />
                <small v-show="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="3">
            <validation-provider name="TMS ID" #default="{ errors }" rules="">
              <b-form-group label="TMS ID">
                <b-form-input
                  disabled
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.TMS_ID"
                />
                <small v-show="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider
              :name="$t('email')"
              #default="{ errors }"
              rules="email|required"
            >
              <b-form-group>
                <label>{{ $t("email") }}<span class="required">*</span> </label>

                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.EMAIL"
                  :placeholder="$t('email')"
                  :error-messages="errors"
                />
                <small v-show="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <validation-provider
              name="Mobile"
              #default="{ errors }"
              rules="regex:^([0-9]+)$"
            >
              <b-form-group :label="$t('phone')">
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.MOBILE"
                  :placeholder="$t('phone')"
                />
                <small v-show="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6" v-show="false">
            <b-form-group :label="$t('position')">
              <v-select
                :getOptionLabel="(member_types) => member_types.NAME"
                v-model="member_type"
                :options="member_types"
                :clearable="false"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <label>{{ $t("gender") }}<span class="required">*</span> </label>

              <b-row class="pw-1">
                <b-col cols="4">
                  <b-form-radio v-model="gender" name="some-radios" value="1">
                    {{ $t("Male") }}
                  </b-form-radio>
                </b-col>
                <b-col cols="4">
                  <b-form-radio v-model="gender" name="some-radios" value="2">
                    {{ $t("Female") }}
                  </b-form-radio>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label="">
              <b-form-checkbox switch v-model="currentItem.STATUS">
                {{ $t("status") }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-edit')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handleOk"
          class="btn round"
        >
          {{ modal_title == $t("updateUser") ? $t("update") : $t("add") }}
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-permission"
      scrollable
      body-class="p-0"
      :title="$t('updateRoleForUser')"
      @ok="handPermission"
    >
      <b-table responsive="sm" hover :items="permisItems" :fields="perFields">
        <template #cell(name)="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>
        <template #cell(C)="row">
          <b-form-checkbox v-model="row.item.C" />
        </template>
        <template #cell(R)="row">
          <b-form-checkbox v-model="row.item.R" />
        </template>
        <template #cell(U)="row">
          <b-form-checkbox v-model="row.item.U" />
        </template>
        <template #cell(D)="row">
          <b-form-checkbox v-model="row.item.D" />
        </template>
      </b-table>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-permission')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handPermission"
          class="btn round"
        >
          {{ $t("update") }}
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-pass"
      scrollable
      :title="$t('changePassword')"
      @ok="handChangePass"
    >
      <validation-observer ref="simpleRulesChangePass">
        <!-- <validation-provider #default="{ errors }" rules="required">
        <b-form-group label="Mật khẩu hiện tại" >
          <b-form-input type="password" :state="errors.length > 0 ? false:null" v-model="changepass.old" placeholder="Mật khẩu hiện tại"/>
        </b-form-group>
      </validation-provider> -->
        <validation-provider
          :name="$t('newPassword')"
          #default="{ errors }"
          rules="required"
        >
          <b-form-group>
            <label
              >{{ $t("newPassword") }}<span class="required">*</span>
            </label>

            <b-form-input
              id="idPass"
              type="password"
              :state="errors.length > 0 ? false : null"
              v-model="changepass.newPass"
              autocomplete="new-password"
              :placeholder="$t('newPassword')"
            />
            <small v-show="errors.length" class="text-danger">{{
              errors[0]
            }}</small>
          </b-form-group>
        </validation-provider>
        <validation-provider
          :name="$t('ReEnterNewPassword')"
          #default="{ errors }"
          rules="required"
        >
          <b-form-group>
            <label
              >{{ $t("ReEnterNewPassword") }}<span class="required">*</span>
            </label>

            <b-form-input
              type="password"
              :state="errors.length > 0 ? false : null"
              v-model="changepass.retype"
              :placeholder="$t('ReEnterNewPassword')"
            />
            <small v-show="errors.length" class="text-danger">{{
              errors[0]
            }}</small>
          </b-form-group>
        </validation-provider>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-pass')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handChangePass"
          class="btn round"
        >
          {{ $t("update") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-info"
      no-close-on-backdrop
      size="xl"
      title="Sale info booking"
    >
      <b-row>
        <b-col class="col-12">
          <b-row>
            <b-col cols="4">
              <b-form-group>
                <label>Service Type</label>

                <!-- <multiselect
                  placeholder="Select Service Type"
                  v-model="searchServiceTypeID"
                  :options="service_types"
                  label="text"
                  track-by="id"
                  :searchable="true"
                  :show-labels="false"
                /> -->
                <Select4
                    v-model="searchServiceTypeID"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      all: true,
                      label: 'text',
                      data: service_types,
                      fields: [
                        { field: 'text', label: 'text' },
                      ],
                    }"
                  />
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group>
                <label>Company</label>

                <!-- <multiselect
                  placeholder="Select Service Type"
                  v-model="searchCompanyID"
                  :options="company_list"
                  label="text"
                  track-by="code"
                  :searchable="true"
                  :show-labels="false"
                /> -->
                <Select4
                    v-model="searchCompanyID"
                    :options="{
                      isSearch: true,
                      value: 'code',
                      all: true,
                      label: 'text',
                      data: company_list,
                      fields: [
                        { field: 'text', label: 'text' },
                      ],
                    }"
                  />
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group>
                <label>UserName</label>
                <b-form-input
                  v-model="searchCustomerID"
                  class="d-inline-block"
                  placeholder="Enter Username"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <vue-good-table
            :columns="columns"
            ref="table"
            :rows="itemRows"
            :line-numbers="true"
            :select-options="{ enabled: true, disableSelectInfo: true }"
            :pagination-options="{
              enabled: true,
              perPageDropdown: [20, 50, 100],
              dropdownAllowAll: false,
              nextLabel: 'Sau',
              prevLabel: 'Trước',
              ofLabel: '/',
              rowsPerPageLabel: 'Số bản ghi',
            }"
            mode="remote"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            :totalRows="totalItemRows"
          >
            <template slot="table-row" slot-scope="props">
              <!-- Column: Action -->
              <span v-if="props.column.field === 'status_id'">
                {{
                  props.row.status_id
                    ? $Utils.CONSTANTS.STATUS_BOOKING[props.row.status_id]
                    : "N/A"
                }}
              </span>
            </template>
          </vue-good-table>
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-info')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          @click="updateSaleForBookings"
          variant="primary"
          size="sm"
          class="btn round"
        >
          Submit
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-sale" no-close-on-backdrop size="md" title="Add Sale">
      <b-row>
        <b-col class="col-12">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Sale</label>

                <multiselect
                  placeholder="Select Saler"
                  v-model="newSaleID"
                  :options="sales"
                  label="text"
                  track-by="id"
                  :searchable="true"
                  :show-labels="false"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-sale')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          @click="updateSale"
          variant="primary"
          size="sm"
          class="btn round"
        >
          Submit
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import vSelect from "vue-select";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import router from "@/router";
import { mapState, mapActions } from "vuex";
export default {
  props: ["saleID", "modal", "serviceTypeId", "customerId"],
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },

  data() {
    return {
      items: [],
      permisItems: [],
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      searchQuery: "",
      gender: null,
      member_type: {},
      currentItem: {},
      changepass: {},
      modal_title: this.$i18n.t(this.$i18n.t("addUser")),
      is_insert: true,
      option_genders: this.$Utils.CONSTANTS.GENDER_A,
      member_types: [],
      // user_types: this.$Utils.CONSTANTS.USER_TYPE_A.filter(x => x.value == this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale),
      fields: [],
      perFields: [
        {
          key: "ROLE_NAME",
          sortable: false,
          label: this.$i18n.t("name"),
        },
        {
          key: "C",
          sortable: true,
          label: "#",
        },
      ],
      columns: [
        {
          label: "ID",
          field: "id",
          filterOptions: {
            enabled: false,
            placeholder: " ",
          },
        },
        {
          label: "Service Type",
          field: "service_type",
          filterOptions: {
            enabled: false,
            placeholder: "",
          },
        },
        {
          label: "Status",
          field: "status_id",
          filterOptions: {
            enabled: false,
            placeholder: "",
          },
        },
        {
          label: "Sale",
          field: "sale_id",
          filterOptions: {
            enabled: false,
            placeholder: "",
          },
        },
        {
          label: "Sale Name",
          field: "user_sale_name",
          filterOptions: {
            enabled: false,
            placeholder: "",
          },
        },
        {
          label: "Customer ID",
          field: "customer_id",
          filterOptions: {
            enabled: false,
            placeholder: "",
          },
        },

        {
          label: "Company",
          field: "customer_company_name",
          filterOptions: {
            enabled: false,
            placeholder: "Date",
          },
        },
      ],
      itemRows: [],
      totalItemRows: 0,
      searchTerm: "",
      currentItemPage: 1,
      perItemPage: 20,
      searchServiceTypeID: "",
      searchCompanyID: "",
      searchCustomerID: "",
      newSaleID: "",
      currentSaleID: "",
    };
  },
  async created() {},
  async mounted() {
    this.currentSaleID = this.saleID || "";

    await this.init();
    await this.fetchUser();
    useJwt
      .get("masterData", { params: { data: "member_types" } })
      .then((response) => {
        this.member_types = response.data.result;
      })
      .catch((error) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            text: this.$i18n.t("errorSystem"),
            icon: "XIcon",
            variant: "danger",
          },
        });
      });
    this.fields = [
      {
        key: "ID",
        sortable: false,
        label: "ID",
      },
      {
        key: "FAST_ID",
        sortable: false,
        label: "FastId",
      },
      {
        key: "MA_NV",
        sortable: false,
        label: this.$i18n.t("staffCode"),
      },
      {
        key: "FULL_NAME",
        sortable: false,
        label: this.$i18n.t("fullName"),
      },
      {
        key: "MOBILE",
        label: this.$i18n.t("phone"),
        sortable: false,
      },
      {
        key: "EMAIL",
        label: this.$i18n.t("email"),
        sortable: false,
      },
      {
        key: "actions",
        label: this.$i18n.t("actions"),
        thClass: "text-center",
        tdClass: "nameOfTheClass",
      },
    ];
  },
  watch: {
    ...[
      "currentItemPage",
      "perItemPage",
      "searchServiceTypeID",
      "searchCompanyID",
      "searchCustomerID",
    ].reduce(
      (watchers, key) => ({
        ...watchers,
        [key](newVal, oldVal) {
          this.$loading.show();

          this.getListBookingBySale();
        },
      }),
      {}
    ),
    perPage: function (n, o) {
      this.$loading.show();

      this.fetchUser();
    },
    searchQuery: function (n, o) {
      if (this.searchQuery == "") {
        this.$loading.show();

        this.fetchUser();
      }
    },
    currentPage: function (n, o) {
      this.$loading.show();

      this.fetchUser();
    },
    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;

      this.fields = [];

      this.$nextTick(() => {
        // Add the component back in

        this.fields = [
          {
            key: "ID",
            sortable: false,
            label: "ID",
          },
          {
            key: "FAST_ID",
            sortable: false,
            label: "FastId",
          },
          {
            key: "MA_NV",
            sortable: false,
            label: this.$i18n.t("staffCode"),
          },
          {
            key: "FULL_NAME",
            sortable: false,
            label: this.$i18n.t("fullName"),
          },
          {
            key: "MOBILE",
            label: this.$i18n.t("phone"),
            sortable: false,
          },
          {
            key: "EMAIL",
            label: this.$i18n.t("email"),
            sortable: false,
          },
          {
            key: "actions",
            label: this.$i18n.t("actions"),
            tdClass: "nameOfTheClass",
            thClass: "text-center",
          },
        ];

        this.renderComponent = true;
      });
    },
  },
  computed: {
    ...mapState("masterData", ["sales", "service_types", "companyItems"]),
    company_list() {
      return this.companyItems;
    },
  },
  methods: {
    ...mapActions("masterData", [
      "fetchSaler",
      "fetchServiceTypes",
      "fetchCompany",
    ]),

    init() {
      this.$loading.show();
      this.fetchSaler();
      this.fetchServiceTypes();
      this.fetchCompany();
      if (this.modal) {
        this.currentSaleID = this.saleID;
        this.searchCustomerID = this.customerId;
        this.searchServiceTypeID = this.service_types.filter(
          (e) => e.id == this.serviceTypeId
        );

        this.getListBookingBySale();
        this.$bvModal.show("modal-info");
      }
    },

    onPageChange(params) {
      this.currentItemPage = params.currentPage;
    },
    onPerPageChange(params) {
      this.perItemPage = params.currentPerPage;
    },

    onSearch() {
      if (this.searchQuery) {
        this.$loading.show();

        this.fetchUser();
      }
    },
    fetchPermission: function () {
      this.permisItems = [];
      useJwt
        .get(`userGroup/${this.currentItem.ID}`, {})
        .then((response) => {
          this.permisItems = response.data.result;
          this.permisItems.forEach(function (i, v) {
            i.C = i.C == 1 ? true : false;
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        });
    },
    fetchUser: function () {
      useJwt
        .get("organization", {
          params: {
            search: this.searchQuery.trim(),
            page: this.currentPage,
            pageSize: this.perPage,
          },
        })
        .then((response) => {
          this.items = response.data.result;
          this.totalRows = response.data.meta.total;
        })
        .catch((error) => {
          this.$loading.hide();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    Permission(item, index, button) {
      this.currentItem = item;
      this.fetchPermission();
      this.$bvModal.show("modal-permission");
    },
    ChangePas(item, index, button) {
      this.currentItem = {};
      this.currentItem = item;
      this.$bvModal.show("modal-pass");
      this.changepass.newPass = "";
      this.changepass = {};
    },
    Edit(item, index, button) {
      this.currentItem = item;
      this.gender = item.GENDER_ID.toString();
      this.member_type = this.member_types.find(
        (e) => e.ID === item.MEMBER_TYPE_ID
      );
      this.currentItem.STATUS = item.STATUS_ID == 1 ? true : false;
      this.currentItem.FAST_ID = item.FAST_ID;

      this.is_insert = false;
      this.modal_title = this.$i18n.t("updateUser");
      this.$bvModal.show("modal-edit");
    },
    taskInfoBooking(item) {
      this.currentSaleID = item.ID;
      if (!this.modal) {
        this.searchCustomerID = "";
        this.searchCompanyID = "";
        this.searchServiceTypeID = "";
      }
      this.$loading.show();

      this.getListBookingBySale();

      this.$bvModal.show("modal-info");
    },
    updateSaleForBookings() {
      const itemsSelects = this.$refs["table"].selectedRows;
      if (itemsSelects.length == 0) {
        return this.$toast.error({
          component: ToastificationContent,
          props: {
            text: "Bạn chưa chọn dữ liệu thay đổi!.",
            icon: "XIcon",
            variant: "danger",
          },
        });
      }
      this.newSaleID = "";

      this.$bvModal.show("modal-sale");

      // console.log(itemsSelects);
    },
    updateSale() {
      const itemsSelects = this.$refs["table"].selectedRows;
      var mapItem = itemsSelects.map((i) => i.id);
      this.$loading.show();

      useJwt
        .put("updateSaleForBookings", {
          saleId: this.newSaleID.code,
          bookingIds: mapItem.toString(),
          status: this.$Utils.CONSTANTS.SALE_EXITS_QUO_BOOK,
        })
        .then((response) => {
          if (response.data.result) {
            this.fetchUser();

            this.$bvModal.hide("modal-sale");
            this.$bvModal.hide("modal-info");

            this.$toast({
              component: ToastificationContent,
              props: {
                text: "Thành công",
                icon: "XIcon",
                variant: "success",
              },
            });
          } else {
            throw Error("Không thành công!");
          }
        })
        .catch((error) => {
          this.$loading.hide();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    getListBookingBySale() {
      useJwt
        .get("getListBookingBySale", {
          params: {
            status: this.$Utils.CONSTANTS.SALE_EXITS_QUO_BOOK,
            saleId: this.currentSaleID || "",
            customerId: this.searchCustomerID || "",
            serviceTypeId: this.searchServiceTypeID?.id || "",
            taxCode: this.searchCompanyID?.id || "",
            page: this.currentItemPage,
            pageSize: this.perItemPage,
          },
        })
        .then((response) => {
          this.itemRows = response.data.result;
          this.totalItemRows = response.data.meta.total;
        })
        .catch((error) => {
          this.$loading.hide();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    New() {
      this.currentItem = { STATUS: true };
      this.member_type = this.member_types[0];
      this.gender = this.$Utils.CONSTANTS.GENDER_O.Male;
      this.is_insert = true;
      this.modal_title = this.$i18n.t("addUser");
      this.$bvModal.show("modal-edit");
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm(
        this.$i18n.t("areYouDelete"),
        {
          title: this.$i18n.t("deleteUser"),
          size: "sm",
          okTitle: this.$i18n.t("ok"),
          cancelTitle: this.$i18n.t("cancel"),
        }
      );
      if (res) {
        useJwt
          .delete(`organization/${this.currentItem.ID}`, {})
          .then((response) => {
            if (response.data.result == "haveData") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("error"),
                  text: this.$i18n.t("haveDataDelete"),
                  icon: "XIcon",
                  variant: "danger",
                },
              });
            } else {
              this.fetchUser();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("success"),
                  text: this.$i18n.t("successfullyDeleted"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          });
      }
    },
    handPermission(bvModalEvt) {
      bvModalEvt.preventDefault();
      useJwt
        .put(`userGroup/${this.currentItem.ID}`, {
          p: this.permisItems.filter((i) => i.C),
        })
        .then((response) => {
          this.fetchPermission();
          this.$bvModal.hide("modal-permission");
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("success"),
              text: this.$i18n.t("successfullyUpdated"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        });
    },
    async handChangePass(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRulesChangePass
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            text: this.$i18n.t("notifyFormError"),
            icon: "XIcon",
            variant: "danger",
          },
        });
        return;
      }
      // var check = await useJwt.get('changepass',{params:{user:this.currentItem.ID,"password":this.changepass.old}}).then(response =>{return response.data.result;}).catch(error => {return error })
      // if (check[0].c!=1){
      //   this.$toast({component: ToastificationContent,props: {title: 'Mật khẩu cũ không chính xác!',icon: 'AlertTriangleIcon',variant: 'warning'}})
      //   return;
      // }
      if (this.changepass.newPass != this.changepass.retype) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title:
              "New password and re-entering new password are not the same!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      // if (this.changepass.new==this.changepass.old){
      //   this.$toast({component: ToastificationContent,props: {title: 'Mật khẩu mới và mật khẩu cũ giống nhau!',icon: 'AlertTriangleIcon',variant: 'warning'}})
      //   return;
      // }

      useJwt
        .put("changePassForUser", {
          id: this.currentItem.ID,
          newPass: this.changepass.newPass,
        })
        .then((response) => {
          this.$bvModal.hide("modal-pass");
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("success"),
              text: this.$i18n.t("successfullyUpdated"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          // setTimeout(function(){
          //   localStorage.clear();
          //   router.push({name:'auth-login'});
          // },3000);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        });
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the input data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      if (!this.is_insert) {
        const data = {
          id: this.currentItem.ID.toLowerCase().trim(),
          maNv: this.currentItem.MA_NV?.trim(),
          fullName: this.currentItem.FULL_NAME.trim(),
          fastId: this.currentItem.FAST_ID?.trim(),

          mobile: this.currentItem.MOBILE?.trim(),
          email: this.currentItem.EMAIL.trim(),
          email: this.currentItem.EMAIL.trim(),
          gender: this.gender.toString(),
          position: this.member_type.ID + "",
          status: this.currentItem.STATUS ? "1" : "0",
        };

        useJwt
          .put(`organization/${this.currentItem.ID}`, data)
          .then((response) => {
            if (response.data.result == "emailExists") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Email ${this.currentItem.EMAIL} already exists!`,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            } else if (response.data.result == "accExists") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Username ${this.currentItem.ID} already exists!`,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            } else {
              this.fetchUser();
              this.$bvModal.hide("modal-edit");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Update success!",
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Update fail",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      } else {
        useJwt
          .post("organization", {
            id: this.currentItem.ID.toLowerCase().trim(),
            maNv: this.currentItem.MA_NV?.trim(),
            fullName: this.currentItem.FULL_NAME.trim(),
            fastId: this.currentItem.fastId?.trim(),
            mobile: this.currentItem.MOBILE?.trim(),
            email: this.currentItem.EMAIL.trim(),
            gender: this.gender.toString(),
            position: this.member_type.ID + "",
            status: this.currentItem.STATUS ? "1" : "0",
          })
          .then((response) => {
            if (response.data.result == "emailExists") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Email ${this.currentItem.EMAIL} already exists!`,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            } else if (response.data.result == "accExists") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Username ${this.currentItem.ID} already exists!`,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            } else {
              this.fetchUser();
              this.$bvModal.hide("modal-edit");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Insert success!",
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Insert fail",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    },
    readonly() {
      return !this.is_insert;
    },
  },
  beforeDestroy() {
    this.$store.commit("masterData/RESET_STATE");
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.gap-10 {
  gap: 10px;
}
.nameOfTheClass {
  width: 250px !important;
  max-width: 250px !important;
}
</style>

